import React from "react";
import PageTitle from "../Common/PageTitle";
import Button from "../Buttons/Button";

const DetailsWrapper = ({ title, children, onClick }) => {
  return (
    <div className="wrapper w-full border border-gray-300 rounded p-2 flex flex-col gap-3">
      <div className="headers rounded px-4 py-2 bg-gray-100 flex justify-between">
        <PageTitle title={title} tag="h6" />
        {onClick && (
          <Button
            type="icon"
            variant="text"
            icon="edit_square"
            color="dark"
            onClick={onClick}
          />
        )}
      </div>
      <div className="content w-full">{children}</div>
    </div>
  );
};

export default DetailsWrapper;
